import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { AuthContainer, Button } from '@/components';
import { useTranslation } from 'react-i18next';

interface PasswordResetSuccessProps {}

const PasswordResetSuccess: FC<PasswordResetSuccessProps> = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const clickHandler = () => {
    navigate('/signin');
  };

  const title = t('translation.password_reset_success_title');
  const description = t('translation.password_reset_success_description');

  return (
    <AuthContainer
      title={title}
      description={description}
      buttons={
        <div>
          <Button size="m" minWidth={240} corner="rect" onClick={clickHandler}>
            {t('translation.ok')}
          </Button>
        </div>
      }
    />
  );
};

export { PasswordResetSuccess };
